// GET VIEW DATA
export const GET_PRE_TEMPLATE = "app/PRE/GET_PRE_TEMPLATE";
export const GET_PRE_TEMPLATE_SUCCESS = "app/PRE/GET_PRE_TEMPLATE_SUCCESS";
export const GET_PRE_TEMPLATE_FAILURE = "app/PRE/GET_PRE_TEMPLATE_FAILURE";

export const SAVE_PRE_TEMPLATE = "app/PRE/SAVE_PRE_TEMPLATE";
export const SAVE_PRE_TEMPLATE_SUCCESS = "app/PRE/SAVE_PRE_TEMPLATE_SUCCESS";
export const SAVE_PRE_TEMPLATE_FAILURE = "app/PRE/SAVE_PRE_TEMPLATE_FAILURE";

// LIST ASSESSMENTS
export const GET_ASSESSMENTS = "app/PRE/GET_ASSESSMENTS";
export const GET_ASSESSMENTS_SUCCESS = "app/PRE/GET_ASSESSMENTS_SUCCESS";
export const GET_ASSESSMENTS_FAILURE = "app/PRE/GET_ASSESSMENTS_FAILURE";

// TOGGLE HISTORY MODAL
export const TOGGLE_HISTORY_MODAL = "app/PRE/TOGGLE_HISTORY_MODAL";

// GET PRE HISTORY
export const GET_PRE_HISTORY = "app/PRE/GET_PRE_HISTORY";
export const GET_PRE_HISTORY_SUCCESS = "app/PRE/GET_PRE_HISTORY_SUCCESS";
export const GET_PRE_HISTORY_FAILURE = "app/PRE/GET_PRE_HISTORY_FAILURE";

// REFRESH CODE
export const REFRESH_CODE = "app/PRE/REFRESH_CODE";
export const REFRESH_CODE_SUCCESS = "app/PRE/REFRESH_CODE_SUCCESS";
export const REFRESH_CODE_FAILURE = "app/PRE/REFRESH_CODE_FAILURE";

// VERIFY PIN
export const VERIFY_PIN = "app/PRE/VERIFY_PIN";
export const VERIFY_PIN_SUCCESS = "app/PRE/VERIFY_PIN_SUCCESS";
export const VERIFY_PIN_FAILURE = "app/PRE/VERIFY_PIN_FAILURE";

// UPLOAD DOC
export const UPLOAD_DOC = "app/PRE/UPLOAD_DOC";
export const UPLOAD_DOC_SUCCESS = "app/PRE/UPLOAD_DOC_SUCCESS";
export const UPLOAD_DOC_FAILURE = "app/PRE/UPLOAD_DOC_FAILURE";

// UPDATE ASSESSMENT
export const SAVE_ASSESSMENT = "app/PRE/SAVE_ASSESSMENT";
export const SAVE_ASSESSMENT_SUCCESS = "app/PRE/SAVE_ASSESSMENT_SUCCESS";
export const SAVE_ASSESSMENT_FAILURE = "app/PRE/SAVE_ASSESSMENT_FAILURE";

// GET ASSESSMENT
export const GET_ASSESSMENT = "app/PRE/GET_ASSESSMENT";
export const GET_ASSESSMENT_SUCCESS = "app/PRE/GET_ASSESSMENT_SUCCESS";
export const GET_ASSESSMENT_FAILURE = "app/PRE/GET_ASSESSMENT_FAILURE";

export const UPDATE_PRE_STATUS = "app/PRE/UPDATE_PRE_STATUS";
export const UPDATE_PRE_STATUS_SUCCESS = "app/PRE/UPDATE_PRE_STATUS_SUCCESS";
export const UPDATE_PRE_STATUS_FAILURE = "app/PRE/UPDATE_PRE_STATUS_FAILURE";

export const GET_UPLOADED_DOCS = "app/PRE/GET_UPLOADED_DOCS";
export const GET_UPLOADED_DOCS_SUCCESS = "app/PRE/GET_UPLOADED_DOCS_SUCCESS";
export const GET_UPLOADED_DOCS_FAILURE = "app/PRE/GET_UPLOADED_DOCS_FAILURE";

export const GET_VIEW_ASSESSMENT = "app/PRE/GET_VIEW_ASSESSMENT";
export const GET_VIEW_ASSESSMENT_SUCCESS =
  "app/PRE/GET_VIEW_ASSESSMENT_SUCCESS";
export const GET_VIEW_ASSESSMENT_FAILURE =
  "app/PRE/GET_VIEW_ASSESSMENT_FAILURE";

export const REPROCESS_DOC = "app/PRE/REPROCESS_DOC";
export const REPROCESS_DOC_SUCCESS = "app/PRE/REPROCESS_DOC_SUCCESS";
export const REPROCESS_DOC_FAILURE = "app/PRE/REPROCESS_DOC_FAILURE";
